import React, {useMemo} from 'react';
import {Form, Edit, Textarea, Suggestions, Flex, List} from 'components';
import {useNamedSelector} from 'helpers';

export function PassionSummary() {
  const options = useNamedSelector('identity.passionSummary');
  const PassionSuggestions = useMemo(() => options.length > 0 && (props =>
    <Suggestions.List {...props}>
      { options.map(option =>
        <p key={option}>{ option }</p>
      ) }
    </Suggestions.List>
  ), []);
  return (
    <Form {...useNamedSelector('identity.form', { name: 'passion-summary' })}>
      <List tiny-gutter>
        <List.Title>Prioritize your list of passions. Which one has the greatest impact on your life? Which one has the second strongest influence, etc.?</List.Title>
        <Edit name="1" Suggestions={PassionSuggestions} />
        <Edit name="2" Suggestions={PassionSuggestions} />
        <Edit name="3" Suggestions={PassionSuggestions} />
        <List.Title>Your top values and passions will help you keep your life connected to what matters most to you. You will soon realize that making decisions becomes easier and that your life begins to feel more purposeful and passionate.</List.Title>
        <List.Title>Are you occupied most of the time doing the things you love to do?</List.Title>
        <Edit name="4" />
        <List.Title>What can you do now to bring even more passion into your life? What can you do to fully utilize your Passion? How can you do more of what you like to do the most?</List.Title>
        <Flex even stack>
          <Textarea single name="5" />
          <Textarea single name="6" />
          <Textarea single name="7" />
        </Flex>
        <List.Title>If you answered no, which steps and/or activities could you start that will enable you to spend more of your time around your passions?</List.Title>
        <Flex even stack>
          <Textarea single name="8" />
          <Textarea single name="9" />
          <Textarea single name="10" />
        </Flex>
      </List>
    </Form>
  );
}
